import * as yup from 'yup'
import { requiredMessage } from 'validation'

export const filterSchema = yup.object().shape({
    filters: yup
      .array()
      .of(
        yup.object().shape({
          column: yup.string().required(requiredMessage),
          operator: yup.string().required(requiredMessage),
          valueType: yup
            .string()
            .oneOf(['String', 'Number', 'Boolean', 'Datetime'])
            .required(requiredMessage),
            value: yup
            .string().trim(),
          values: yup
            .array()
            .of(yup.string().required(requiredMessage))
            .min(1, 'At least one value must be added')
            .required(requiredMessage)
            .test('values-required', 'At least one value must be added', function (value) {
              return !!(value && value.length > 0 && value.some(v => v && v.trim() !== ''))
            }),
        })
      )
      .required(),
  })